import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Loader from "../components/Loader";
import Languages from "../components/Languages";
import API from "../services/api";
import moment from "moment";

export default class Home extends Component {
  constructor(props) {
    super(props);

    let language = localStorage.getItem("language");

    this.state = {
      isLoading: true,
      page: null,
      modalOpen: false,
      me: null,
      name: "",
      email: "",
      lang: null,
      language:
        ["en", "cz", "hr", "hu", "ru", "sk", "si"].indexOf(language) !== -1
          ? language
          : "en",
      languages: [],
      nominationLanguages: [],
      nominationResearch: null,
      research: null,
      researchList: [],
      relation: 0,
      relations: [],
      raters: [],
      employees: [],
      selectedEmployee: "",
      isNewRater: false,
      employeeSearch: "",
      showEmployeeDropdown: false,
      invitesCompleted: false,
    };
  }

  componentDidMount() {
    this.loadData();
    this.props.showLogout(true);
  }

  loadData = async () => {
    let research;
    let researchList = [];

    await API.get("", {
      params: {
        action: "me",
      },
    })
      .then((response) => {
        this.setState({
          me: response.data,
        });
      })
      .catch((error) => {});

    await API.get("", {
      params: {
        action: "languages",
      },
    })
      .then((response) => {
        let data = response.data;
        let currentLanguage = this.state.language;
        let languageFound = false;

        for (let i in data) {
          if (data[i].id === currentLanguage) {
            languageFound = true;
          }
        }

        if (!languageFound) {
          localStorage.setItem("language", data[0].id);
          window.location.reload();
          return false;
        }

        this.setState({
          languages: data,
        });
      })
      .catch((error) => {});

    await API.get("", {
      params: {
        action: "research",
        language: this._getCurrentLanguage(),
      },
    })
      .then((response) => {
        research = response.data;

        this.setState({
          research: research,
        });
      })
      .catch((error) => {});

    await API.get("", {
      params: {
        action: "researchList",
        language: this._getCurrentLanguage(),
      },
    })
      .then((response) => {
        researchList = response.data;

        this.setState({
          researchList: response.data,
        });
      })
      .catch((error) => {});

    await API.get("", {
      params: {
        action: "home",
        language: this.props.getLanguage(),
      },
    })
      .then((response) => {
        this.setState({
          page: response.data,
        });
      })
      .catch((error) => {});

    await API.get("", {
      params: {
        action: "translations",
        slug: "home",
        language: this.props.getLanguage(),
      },
    })
      .then((response) => {
        this.setState({
          t: response.data,
        });
      })
      .catch((error) => {});

    for (let item of researchList) {
      if (item.nomination_active) {
        this.setState({
          nominationResearch: item,
          invitesCompleted: !!item.invites_completed_at,
        });

        await API.get("", {
          params: {
            action: "relations",
            researchId: item.id,
            language: this._getCurrentLanguage(),
          },
        })
          .then((response) => {
            this.setState({
              relations: response.data,
            });
          })
          .catch((error) => {});

        await API.get("", {
          params: {
            action: "employees",
          },
        })
          .then((response) => {
            this.setState({
              employees: response.data || [],
            });
          })
          .catch((error) => {});

        await this._loadRaters(item.id);

        this.setState({
          nominationLanguages: [
            { id: "en", name: "English" },
            { id: "hr", name: "Croatian" },
            { id: "hu", name: "Hungarian" },
            { id: "cz", name: "Czech" },
            { id: "sk", name: "Slovak" },
          ],
        });
      }
    }

    this.setState({
      isLoading: false,
    });
  };

  _loadRaters = async (researchId) => {
    await API.get("", {
      params: {
        action: "raters",
        researchId: researchId,
        language: this._getCurrentLanguage(),
      },
    })
      .then((response) => {
        this.setState({
          raters: response.data,
        });
      })
      .catch((error) => {});
  };

  _inviteOnClick = (event) => {
    this.setState({
      modalOpen: true,
      selectedEmployee: "",
      isNewRater: false,
      name: "",
      email: "",
      employeeSearch: "",
      showEmployeeDropdown: false,
    });
  };

  _inviteOnClose = (event) => {
    this.setState({
      modalOpen: false,
    });
  };

  _inviteOnSubmit = async (event) => {
    event.preventDefault();

    await API.post("", {
      action: "raterSubmit",
      name: this.state.name,
      email: this.state.email,
      researchId: this.state.nominationResearch.id,
      relation: parseInt(this.state.relation, 10),
      lang: this._getLanguage(this.state.lang),
    })
      .then((response) => {})
      .catch((error) => {
        window.alert(this._t("home_generic_error"));
      });

    this.setState({
      modalOpen: false,
    });

    await this._loadRaters(this.state.nominationResearch.id);
  };

  _inviteOnRemove = async (event) => {
    if (!window.confirm(this._t("home_remove_rater_confirm"))) {
      return false;
    }

    await API.post("", {
      action: "raterRemove",
      id: event.target.dataset.id,
    })
      .then((response) => {
        this._loadRaters(this.state.nominationResearch.id);
      })
      .catch((error) => {
        window.alert(this._t("home_generic_error"));
      });
  };

  _completeNominations = async () => {
    if (!window.confirm(this._t("home_complete_nominations_confirm"))) {
      return;
    }

    await API.post("", {
      action: "nominationComplete",
      researchId: this.state.nominationResearch.id,
    })
      .then((response) => {
        this.setState({ invitesCompleted: true });
      })
      .catch((error) => {
        window.alert(this._t("home_generic_error"));
      });
  };

  _getRelationStatus = () => {
    const { relations, raters } = this.state;

    return relations.map((relation) => {
      const count = raters.filter(
        (r) => r.relation === relation.id
      ).length;
      return {
        ...relation,
        count,
        satisfied: !relation.min_count || count >= relation.min_count,
      };
    });
  };

  _inputOnChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  _employeeSearchOnChange = (event) => {
    this.setState({
      employeeSearch: event.target.value,
      showEmployeeDropdown: true,
      selectedEmployee: "",
      isNewRater: false,
      name: "",
      email: "",
    });
  };

  _employeeSearchOnFocus = () => {
    this.setState({ showEmployeeDropdown: true });
  };

  _employeeSearchOnBlur = () => {
    setTimeout(() => {
      this.setState({ showEmployeeDropdown: false });
    }, 200);
  };

  _selectEmployee = (employee) => {
    if (employee === "new") {
      this.setState({
        selectedEmployee: "new",
        isNewRater: true,
        employeeSearch: "",
        showEmployeeDropdown: false,
        name: "",
        email: "",
      });
    } else {
      this.setState({
        selectedEmployee: employee.id.toString(),
        isNewRater: false,
        employeeSearch: `${employee.name} (${employee.email})`,
        showEmployeeDropdown: false,
        name: employee.name,
        email: employee.email,
      });
    }
  };

  _getFilteredEmployees = () => {
    const { employees, employeeSearch } = this.state;
    const search = employeeSearch.toLowerCase().trim();
    if (!search) return employees;
    return employees.filter(
      (e) =>
        e.name.toLowerCase().includes(search) ||
        e.email.toLowerCase().includes(search)
    );
  };

  _getReleationTitle = (id) => {
    let relations = this.state.relations;

    for (let i in relations) {
      if (relations[i].id === id) {
        return relations[i].content;
      }
    }
  };

  _getCurrentLanguage = () => {
    return this._getLanguage(localStorage.getItem("language"));
  };

  _getLanguage = (id) => {
    let languages = this.state.languages;

    for (let i in languages) {
      if (languages[i].id === id) {
        return languages[i].id;
      }
    }

    return languages[0].id;
  };

  _t = (key) => {
    return this.state.t[key];
  };

  render() {
    const {
      isLoading,
      modalOpen,
      raters,
      relations,
      me,
      name,
      email,
      researchList,
      relation,
      lang,
      nominationLanguages,
      page,
      t,
      employees,
      selectedEmployee,
      isNewRater,
      employeeSearch,
      showEmployeeDropdown,
      invitesCompleted,
    } = this.state;

    const filteredEmployees = this._getFilteredEmployees().slice(0, 5);
    const relationStatus = this._getRelationStatus();
    const allRelationsSatisfied = relationStatus.every((r) => r.satisfied);

    if (isLoading) {
      return <Loader />;
    }

    return (
      <div className="page">
        <Languages />
        <h1 className="page__heading">
          {t.home_welcome} {me.name}!
        </h1>
        <div className="page__content">
          {page !== null && (
            <article
              className="page__intro"
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          )}
          {researchList.map((item, key) => (
            <div key={key}>
              <h2>{item.title}</h2>
              <p>{item.description}</p>
              {item.nomination_active && (
                <div className="research__nomination">
                  {invitesCompleted ? (
                    <p className="research__nomination__completed">
                      <strong>{t.home_nominations_completed || "Your nominations have been completed."}</strong>
                    </p>
                  ) : (
                    <>
                      {raters.length === 0 ? (
                        <p>{t.home_no_raters}</p>
                      ) : (
                        <div>
                          <h3>{t.home_your_raters}</h3>
                          <table className="table">
                            <thead>
                              <tr>
                                <th>{t.home_name}</th>
                                <th>{t.home_email}</th>
                                <th>{t.home_relation}</th>
                                <th>{t.home_language}</th>
                                <th />
                              </tr>
                            </thead>
                            <tbody>
                              {raters.map((rater, raterKey) => (
                                <tr key={raterKey}>
                                  <td>{rater.name}</td>
                                  <td>{rater.email}</td>
                                  <td>{this._getReleationTitle(rater.relation)}</td>
                                  <td>{rater.language.toUpperCase()}</td>
                                  <td className="table__cell--clear">
                                    <span
                                      data-id={rater.id}
                                      className="remove"
                                      onClick={this._inviteOnRemove}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                      {relationStatus.filter((r) => !r.satisfied).length > 0 && (
                        <div className="research__nomination__warnings">
                          {relationStatus
                            .filter((r) => !r.satisfied)
                            .map((r) => (
                              <p key={r.id} className="research__nomination__warning">
                                {(t.home_min_raters || "You need at least :min_count rater(s) for :relation.")
                                  .replace(":min_count", r.min_count)
                                  .replace(":relation", r.content)}{" "}
                                ({r.count}/{r.min_count})
                              </p>
                            ))}
                        </div>
                      )}
                      <p className="research__nomination__info">
                        <em>
                          {t.home_rater_deadline}{" "}
                          <strong>
                            {moment(item.invite_ends_at).format(
                              t.generic_date_format
                            )}
                          </strong>
                        </em>
                      </p>
                      <div>
                        <span
                          className="button"
                          to="/invite"
                          onClick={this._inviteOnClick}
                        >
                          {t.home_add_rater}
                        </span>
                        {allRelationsSatisfied && raters.length > 0 && (
                          <>
                            {" "}
                            <span
                              className="button"
                              onClick={this._completeNominations}
                            >
                              {t.home_complete_nominations || "Complete Nominations"}
                            </span>
                          </>
                        )}
                        <br />
                        <br />
                      </div>
                    </>
                  )}
                </div>
              )}
              {item.research_active && (
                <div className="research__survey">
                  {item.surveys && item.surveys.length > 0 ? (
                    <div className="research__survey__list">
                      {item.surveys.map((survey, surveyKey) => (
                        <div
                          key={surveyKey}
                          className={`research__survey__item ${
                            item.completeness === 100
                              ? " research__survey__item--completed"
                              : ""
                          }`}
                        >
                          <h3>
                            <NavLink to={`/rate/${survey.id}`}>
                              {survey.relation === null &&
                              item.relation_type !== "satisfaction"
                                ? t.generic_self_assessment
                                : survey.user}
                            </NavLink>
                          </h3>
                          <h4>{survey.questionnaire}</h4>
                          <span className="research__survey__item__completeness">
                            {survey.completeness}
                            <span>%</span>
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="reserarch__survey_info error">
                      {t.home_survey_missing}
                    </p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
        {modalOpen && (
          <div className="modal">
            <div className="modal__content">
              <form className="form" onSubmit={this._inviteOnSubmit}>
                {employees.length > 0 ? (
                  <>
                    <fieldset className="fieldset">
                      <label className="label">
                        {t.home_add_rater || "Add Rater"}
                      </label>
                      <div className="autocomplete">
                        <input
                          type="text"
                          className="input"
                          placeholder={t.home_please_select}
                          value={employeeSearch}
                          onChange={this._employeeSearchOnChange}
                          onFocus={this._employeeSearchOnFocus}
                          onBlur={this._employeeSearchOnBlur}
                          autoComplete="off"
                        />
                        {showEmployeeDropdown && (
                          <div className="autocomplete__dropdown">
                            {filteredEmployees.map((employee, key) => (
                              <div
                                key={key}
                                className="autocomplete__item"
                                onMouseDown={() =>
                                  this._selectEmployee(employee)
                                }
                              >
                                {employee.name} ({employee.email})
                              </div>
                            ))}
                            <div
                              className="autocomplete__item autocomplete__item--add"
                              onMouseDown={() => this._selectEmployee("new")}
                            >
                              {t.home_add_new_rater || "Add New Rater"}
                            </div>
                          </div>
                        )}
                      </div>
                    </fieldset>
                    {isNewRater && (
                      <>
                        <fieldset className="fieldset">
                          <label className="label">{t.home_name}</label>
                          <input
                            type="text"
                            required={true}
                            name="name"
                            className="input"
                            value={name}
                            onChange={this._inputOnChange}
                          />
                        </fieldset>
                        <fieldset className="fieldset">
                          <label className="label">{t.home_email}</label>
                          <input
                            type="email"
                            required={true}
                            name="email"
                            className="input"
                            value={email}
                            onChange={this._inputOnChange}
                          />
                        </fieldset>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <fieldset className="fieldset">
                      <label className="label">{t.home_name}</label>
                      <input
                        type="text"
                        required={true}
                        name="name"
                        className="input"
                        value={name}
                        onChange={this._inputOnChange}
                      />
                    </fieldset>
                    <fieldset className="fieldset">
                      <label className="label">{t.home_email}</label>
                      <input
                        type="email"
                        required={true}
                        name="email"
                        className="input"
                        value={email}
                        onChange={this._inputOnChange}
                      />
                    </fieldset>
                  </>
                )}
                <fieldset className="fieldset">
                  <label className="label">{t.home_relation}</label>
                  <select
                    required={true}
                    name="relation"
                    className="input"
                    value={relation}
                    onChange={this._inputOnChange}
                  >
                    <option value="">{t.home_please_select}</option>
                    {relations.map((item, key) => (
                      <option key={key} value={item.id}>
                        {item.content}
                      </option>
                    ))}
                  </select>
                </fieldset>
                {nominationLanguages.length > 1 && (
                  <fieldset className="fieldset">
                    <label className="label">{t.home_language}</label>
                    <select
                      required={true}
                      name="lang"
                      className="input"
                      value={lang}
                      onChange={this._inputOnChange}
                    >
                      {nominationLanguages.map((item, key) => (
                        <option key={key} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </fieldset>
                )}
                <fieldset className="fieldset">
                  <button
                    type="submit"
                    className="button"
                    disabled={employees.length > 0 && !selectedEmployee}
                  >
                    {t.home_add_rater}
                  </button>
                </fieldset>
              </form>
            </div>
            <div className="modal__close" onClick={this._inviteOnClose} />
          </div>
        )}
      </div>
    );
  }
}
